<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3" outlined style="overflow: auto">
            <v-toolbar flat height="90" class="mb-3">
                    <div class="d-flex flex-column pt-6">
                        <v-btn
                            color="secondary"
                            class="text-capitalize px-5 "
                            depressed
                            @click="dialog = true"
                            >{{ translations.createOrder[lang] }}</v-btn
                        >
                        <v-col>
                            <ExportLinks
                                @exportCSV="exportFile({q: search || null})"
                                @deleteCSV="
                                    deleteExportedFile(exportedFile.user_store_export_id)
                                "
                                :buttonStatusCSV="exportCsvStatus"
                                :urlCSV="
                                    exportedFile && exportedFile.url ? exportedFile.url : ''
                                "
                                :createdAt="exportedFile ? exportedFile.created_at : ''"
                            />
                    </v-col>
                    </div>

                        <v-spacer></v-spacer>

                        <v-col cols="12" md="4" class="pa-0 mb-0 d-flex align-end" style="height: 100%;">
                            <b-search-field v-model="search"></b-search-field>
                        </v-col>
            </v-toolbar>
            <v-data-table
                :headers="headers"
                :loading="loading"
                :items="loyaltyCards"
                :footer-props="{
                    itemsPerPageOptions: [12],
                    showCurrentPage: true,
                    pageText: `${page * 12 - 11}-${
                        page * 12 <= serverItemsLength
                            ? page * 12
                            : serverItemsLength
                    } ${translations.paginationText[lang]} ${serverItemsLength}`
                }"
                :page.sync="page"
                :server-items-length="serverItemsLength"
                :options.sync="options"
                class="b-outlined"
            >
                <template v-slot:item.used="{ item }">
                    <v-icon
                        v-if="item.user_id"
                        color="green"
                        v-text="icons.mdiCheckCircleOutline"
                    ></v-icon>
                    <v-icon
                        v-else
                        color="red"
                        v-text="icons.mdiMinusCircleOutline"
                    ></v-icon>
                </template>

                <!-- <template v-slot:item.actions="{ item }">
                    <v-tooltip color="secondary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                color="red"
                                icon
                                v-on="on"
                                @click="
                                    () => {
                                        openDeleteDialog(item)
                                    }
                                "
                            >
                                <v-icon v-text="icons.mdiClose"></v-icon>
                            </v-btn>
                        </template>

                        <span
                            class="font-weight-bold"
                            v-text="translations.delete[lang]"
                        ></span>
                    </v-tooltip>
                </template> -->
            </v-data-table>

            <v-dialog
                v-model="dialog"
                :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '40%'"
            >
                <LoyaltyCardForm @close="dialog = false" />
            </v-dialog>

            <!-- <v-dialog v-model="deleteDialog" max-width="500">
                <b-card
                    type="delete"
                    title="Delete Point Title"
                    :loading="loading"
                    :error-message="errorMessage"
                    :submit-text="{ el: '', en: 'delete', it: '' }"
                    @cancel="deleteDialog = false"
                    @submit="remove(deletingTitleId)"
                >
                    <div class="subtitle-1 font-weight-medium pl-2">
                        Are you sure you want to delete
                        <span class="font-weight-bold text--primary">Point Title</span>?
                    </div>
                </b-card>
            </v-dialog> -->
        </v-sheet>
    </v-container>
</template>

<script>
import {
    mdiPencilOutline,
    mdiClose,
    mdiCheckCircleOutline,
    mdiMinusCircleOutline
} from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";
import LoyaltyCardForm from "../../components/loyaltyPanel/loyaltyCards/LoyaltyCardForm";
import translations from "@/utils/translations/loyaltyPanel/loyaltyCards";
import debounce from "lodash/debounce";
import ExportLinks from "@/components/general/ExportLinks.vue";

export default {
    name: "LoyaltyCards",

    components: { LoyaltyCardForm, ExportLinks },

    mixins: [translations],

    data() {
        return {
            icons: {
                mdiPencilOutline,
                mdiClose,
                mdiCheckCircleOutline,
                mdiMinusCircleOutline
            },
            page: +this.$route.query.page,
            mode: 1,
            deletingTitleId: null,
            search: "",
            options: {},
            filtersData: {
                o: null
            },
            exportCsvStatus: 1
        };
    },

    computed: {
        ...mapState("loyaltyPanel/loyaltyCards", [
            "loyaltyCards",
            "exportedFile"
        ]),
        ...mapState(["loading", "errorMessage", "serverItemsLength"]),

        dialog: {
            get() {
                return this.$store.state.dialog;
            },

            set(val) {
                this.setDialog(val);
            }
        },

        deleteDialog: {
            get() {
                return this.$store.state.deleteDialog;
            },

            set(val) {
                this.setDeleteDialog(val);
            }
        },

        lang() {
            return this.$route.params.lang;
        },

        headers() {
            return [
                {
                    text: this.translations.card_number[this.lang],
                    value: `card_number`
                },
                {
                    text: this.translations.card_password[this.lang],
                    value: `card_password`
                },
                {
                    text: this.translations.reference_number[this.lang],
                    value: "reference"
                },
                {
                    text: this.translations.card_type[this.lang],
                    value: "card_type",
                    sortable: false
                },
                {
                    text: this.translations.used[this.lang],
                    value: "used"
                },
                {
                    text: this.translations.activated_at[this.lang],
                    value: "activated_at",
                    sortable: false
                }
                // {
                //     text: this.translations.actions[this.lang],
                //     value: "actions",
                // }
            ];
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        }
    },

    methods: {
        ...mapActions("loyaltyPanel/loyaltyCards", [
            "fetchLoyaltyCards",
            "remove",
            "getExportedFile",
            "exportFile",
            "deleteExportedFile"
        ]),
        ...mapMutations(["setDialog", "setDeleteDialog"]),

        openDeleteDialog(item) {
            this.deletingTitleId = item.store_point_title_id;
            this.deleteDialog = true;
        },

        handleSearch() {
            this.page = 1;
            this.fetchLoyaltyCards({
                query: `?q=${this.search}`,
                filters: this.filtersData
            });
        },

        getFilteredData() {
            let sendingData = {
                query: `?page=${this.page}&q=${this.search ? this.search : ""}`,
                filters: this.filtersData
            };
            this.fetchLoyaltyCards(sendingData);
        }
    },

    mounted() {
        this.getFilteredData();
        this.getExportedFile();
    },

    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
    },

    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.push({
                query: {
                    page: 1,
                    ...this.$route.query
                }
            });
        }
    },

    watch: {
        options: {
            handler(val) {
                if (val.sortBy[0]) {
                    if (val.sortBy[0].split("[")[0] === "used") {
                        this.filtersData.o = "activated";
                    } else {
                        this.filtersData.o = val.sortBy[0].split("[")[0];
                    }

                    if (val.sortDesc) {
                        this.filtersData.o +=
                            "," + (val.sortDesc[0] ? "desc" : "asc");
                    }
                    this.getFilteredData();
                }
            },
            deep: true
        },
        $route(val) {
            if (!val.query.page) {
                this.$router.push({
                    query: {
                        page: 1,
                        ...this.$route.query
                    }
                });
            }
            this.getFilteredData();
        },

        page(page) {
            this.$router.push({ query: { ...this.$route.query, page } });
        },

        search(val) {
            if (val == null) {
                this.page = 1;
                this.getFilteredData();
            } else {
                this.debouncedSearch();
            }
        },
        
        exportedFile(val) {
            if (val) {
                if (val.queue) {
                    this.exportCsvStatus = 2;
                } else {
                    this.exportCsvStatus = 3;
                }
            } else {
                this.exportCsvStatus = 1;
            }
        },

        exportCSVStatus(val) {
            if (val) {
                this.exportCsvStatus = 3;
            }
        }
    }
};
</script>
